<script>
export default {
    type: "column2d",
    width: "100%",
    height: "350",
    dataFormat: "json",
    dataSource: {
        chart: {
            // caption: "Countries With Most Oil Reserves [2017-18]",
            // subcaption: "In MMbbl = One Million barrels",
            showvalues: "1",
            xaxisname: "Jenis Kutipan Hasil",
            yaxisname: "Jumlah Kutipan Hasil",
            // numbersuffix: "K",
            numberprefix: "RM",
            theme: "fusion",
        },
        data: [
            {
                label: "Cukai Langsung",
                value: "1927312.0",
                "color": "#FF9F45",
            },
            {
                label: "Cukai Tidak Langsung",
                value: "3164271.14",
                "color": "#F76E11",
            },
        ],
    },
};
</script>
